"use client";

import { motion } from "framer-motion";

const fadeUp = {
  hidden: { opacity: 0, y: 50 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.8, ease: "easeOut" } },
};

const headerVariants = {
  hidden: { opacity: 0, y: 50 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.8, ease: "easeOut" } },
};

const gridContainer = {
  hidden: {},
  visible: { transition: { staggerChildren: 0.2 } },
};

export function Bento() {
  return (
    <section id="services" className="relative px-6 md:px-12 py-32">
      <div className="max-w-[1600px] mx-auto">
        <motion.div
          className="flex items-end justify-between flex-wrap gap-6 mb-16"
          variants={headerVariants}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
        >
          <div>
            <div className="font-mono text-xs uppercase tracking-[0.3em] text-muted-foreground mb-4">
              [002] — Capabilities
            </div>
            <h2 className="font-display uppercase leading-[0.85] text-foreground"
              style={{ fontSize: "clamp(3rem, 8vw, 9rem)" }}>
              What I <span className="text-outline-acid italic font-serif normal-case">actually</span> do.
            </h2>
          </div>
          <p className="max-w-sm font-serif text-xl text-muted-foreground">
            Six sonic stages, one producer. No signal loss, no commercial dilution.
          </p>
        </motion.div>

        <motion.div
          className="grid grid-cols-12 gap-4 md:gap-6 auto-rows-[180px]"
          variants={gridContainer}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
        >
          <motion.div variants={fadeUp} className="glass glass-acid trace-border col-span-12 md:col-span-7 row-span-2 p-8 md:p-10 flex flex-col justify-between rounded-md">
            <div className="font-mono text-[10px] uppercase tracking-widest text-[oklch(0.94_0.27_128)]">01 / Sonic Identity</div>
            <div>
              <h3 className="font-display text-5xl md:text-7xl uppercase leading-none">SONIC IDENTITY WITH <span className="text-outline-acid italic font-serif normal-case">attitude</span></h3>
              <p className="mt-6 max-w-md text-muted-foreground">Audio branding, custom arrangements, and raw sonic personality.</p>
            </div>
          </motion.div>

          <motion.div variants={fadeUp} className="glass trace-border col-span-6 md:col-span-5 row-span-1 p-6 rounded-md flex flex-col justify-between">
            <div className="font-mono text-[10px] uppercase tracking-widest text-muted-foreground">02 / Mixing</div>
            <h3 className="font-display text-3xl uppercase">MIXES THAT SLAP.</h3>
          </motion.div>

          <motion.div variants={fadeUp} className="glass trace-border col-span-6 md:col-span-5 row-span-1 p-6 rounded-md flex flex-col justify-between">
            <div className="font-mono text-[10px] uppercase tracking-widest text-muted-foreground">03 / Recording</div>
            <h3 className="font-display text-3xl uppercase">RECORDING + VOCALS.</h3>
          </motion.div>

          <motion.div variants={fadeUp} className="glass trace-border col-span-12 md:col-span-4 row-span-2 p-8 rounded-md flex flex-col justify-between">
            <div className="font-mono text-[10px] uppercase tracking-widest text-muted-foreground">04 / Production</div>
            <div>
              <h3 className="font-display text-4xl uppercase leading-none">MUSIC PRODUCTION.</h3>
              <p className="mt-4 text-sm text-muted-foreground">From raw demo to radio-ready tracks.</p>
            </div>
          </motion.div>

          <motion.div variants={fadeUp} className="col-span-12 md:col-span-4 row-span-2 p-8 rounded-md bg-[oklch(0.94_0.27_128)] text-[oklch(0.145_0_0)] flex flex-col justify-between">
            <div className="font-mono text-[10px] uppercase tracking-widest">05 / Mastering</div>
            <div>
              <h3 className="font-display text-4xl md:text-5xl uppercase leading-none">LOUDNESS + CLARITY.</h3>
              <p className="mt-4 text-sm opacity-80">Mastering that hits hard on every speaker.</p>
            </div>
          </motion.div>

          <motion.div variants={fadeUp} className="glass trace-border col-span-12 md:col-span-4 row-span-2 p-8 rounded-md flex flex-col justify-between">
            <div className="font-mono text-[10px] uppercase tracking-widest text-muted-foreground">06 / Distribution</div>
            <div>
              <h3 className="font-display text-4xl uppercase leading-none">DISTRIBUTION.</h3>
              <p className="mt-4 text-sm text-muted-foreground">Get your tracks on Spotify and Apple Music in 7 days.</p>
            </div>
          </motion.div>
        </motion.div>
      </div>
    </section>
  );
}
